import * as React from 'react';
import * as styles from './AddressLine.css';

import { SPACE_SYMBOL } from '../../constants/symbolsUnicode';
import { IAddressLine } from '../../types/newbuilding';
import { UIText2 } from '@cian/ui-kit';

interface IAddressLineProps {
  addressLine: IAddressLine[];
}

export function AddressLine(props: IAddressLineProps) {
  const { addressLine } = props;

  if (!addressLine || !addressLine.length) {
    return null;
  }

  return (
    <div className={styles['container']} data-testid="CellAddressBlock">
      {addressLine.map(({ title, fullUrl, qs }, index) => (
        <React.Fragment key={index}>
          {!!index && `,${SPACE_SYMBOL}`}
          <a
            className={styles['link']}
            href={fullUrl || `/newobjects/list?${qs}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <UIText2 display="inline" color="current_color">
              {title}
            </UIText2>
          </a>
        </React.Fragment>
      ))}
    </div>
  );
}
